<template>
	<div>

		<div class="row">

			<div class="col-xs-12 text-right">
				<button class="btn btn-sm btn-primary" @click="$router.push('/cgd/by/user/edit/'+ user.id)">
					<i class="fa fa-pencil"></i>
					编辑
				</button>
			</div>
			<div class="col-xs-12">


				<div class="profile-image">
					<img v-if="user.avatar && user.avatar.url" alt="image" class="img-circle circle-border m-b-md"
					     :src="user.avatar.url"/>
					<img v-else alt="image" class="img-circle circle-border m-b-md"
					     src="../../../common/assets/img/avatar.png"/>
				</div>
				<div class="profile-info">
					<div class="">
						<div>
							<h2 class="no-margins">
								{{user.nickname}}
							</h2>
							<h4>{{user.role.name}}</h4>
							<div class="mb5">
								<i class="fa fa-envelope"></i>
								{{user.email}}
							</div>
							<div class="mb5">
								<i class="fa fa-phone"></i>
								{{user.phone}}
							</div>

							<div class="mb5">
								{{user.description?user.description:"这个人很懒，什么也没写"}}
							</div>
						</div>
					</div>
				</div>


			</div>


		</div>

	</div>

</template>
<script>
	import User from '../../../common/model/user/User'


	export default{
		data(){
			return {
				user: new User()
			}
		},
		watch: {},
		methods: {},
		components: {

		},
		mounted(){
			this.user.id = this.$store.state.route.params.id;
			if (this.user.id === this.$store.state.user.id) {
				this.user = this.$store.state.user;
			}
			if (this.user.id) {
				this.user.httpDetail();
			}


		}
	}
</script>



// WEBPACK FOOTER //
// Profile.vue?1314276b